<template>
  <div>
    <v-tabs
      dark
      color="primary"
      slot="extension"
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab>Producción</v-tab>
      <v-tab>Incidencias</v-tab>
      <v-tab>Pesadas</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <production-report></production-report>
      </v-tab-item>
      <v-tab-item>
        <incidents-report></incidents-report>
      </v-tab-item>
      <v-tab-item>
        <measurements-report></measurements-report>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
import IncidentsReport from '@/partials/IncidentsReport'
import ProductionReport from '@/partials/ProductionReport'
import MeasurementsReport from '@/partials/MeasurementsReport'

export default {
  components: {IncidentsReport, ProductionReport, MeasurementsReport},
  data () {
    return {
      tab: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ReportList.vue